import languages from '../languages/languages';
import hungarianTranslation from '../translations/hungarian';
import Translation from '../translations/Translation';
import Localization from './Localization';

const hungarianLocalization: Localization<Translation> = {
  language: languages.hungarian,
  translatedStrings: hungarianTranslation,
};

export default hungarianLocalization;
